angular.module('filters').filter('membershipPlanTermFilter', ["$filter", function($filter) {
  return function(plan) {
    if (plan.term_number) {
      return $filter('pluralize')(plan.term_unit, plan.term_number, true);
    } else {
      return 'N/A';
    }
  };
}]);
